import { useTranslation } from "react-i18next";
import { useRemoteMutation } from "../useRemote/useRemoteMutation";
import { RemoteApiError } from "../useRemote/types";
import { VehicleInventory } from "../../../components/FleetManagement/types/VehicleInventory.types";

export function useRemoteCreateFleet() {
  const { t } = useTranslation();

  return useRemoteMutation<VehicleInventory, RemoteApiError, FormData>({
    key: ["fleet", "create"],
    url: "/fleet/vehicles",
    method: "post",
    snackbarTextOnSuccess: t("Successfully created vehicle"),
    snackbarTextOnFail: t("There was a server error")
  });
}
